var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5V14C12 15.1046 11.1046 16 10 16H2C0.895431 16 0 15.1046 0 14V2C0 0.89543 0.895431 0 2 0H7.5L12 4.5ZM9 4.5C8.17157 4.5 7.5 3.82843 7.5 3V1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H10C10.5523 15 11 14.5523 11 14V4.5H9Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.5C2.5 12.2239 2.72386 12 3 12H6C6.27614 12 6.5 12.2239 6.5 12.5C6.5 12.7761 6.27614 13 6 13H3C2.72386 13 2.5 12.7761 2.5 12.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.5C2.5 10.2239 2.72386 10 3 10H9C9.27614 10 9.5 10.2239 9.5 10.5C9.5 10.7761 9.27614 11 9 11H3C2.72386 11 2.5 10.7761 2.5 10.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13868 6.79199L5.46815 7.67831L7.32322 5.82323C7.39931 5.74714 7.51556 5.72828 7.6118 5.7764L9.5 6.75001V8.50001C9.5 8.77615 9.27614 9.00001 9 9.00001H3C2.72386 9.00001 2.5 8.77615 2.5 8.50001V8.00001C2.5 8.00001 4.03952 6.72589 4.13868 6.79199Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 6C4.66421 6 5 5.66421 5 5.25C5 4.83579 4.66421 4.5 4.25 4.5C3.83579 4.5 3.5 4.83579 3.5 5.25C3.5 5.66421 3.83579 6 4.25 6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicationIcon);
export default __webpack_public_path__ + "static/media/publication-icon.c480df09c51cc4963d122e298e4750d3.svg";
export { ForwardRef as ReactComponent };